import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static get targets() {
		return ['total', 'input'];
	}

	connect() {
		this.maxChars =
			parseInt(this.element.dataset.letterCountMax, 10) ||
			parseInt(this.inputTarget.getAttribute('maxlength'), 10) ||
			250;

		this.onInput = () => {
			let val = this.inputTarget.value;

			if (val.length > this.maxChars) {
				val = val.substring(0, this.maxChars);
				this.inputTarget.value = val;
			}

			this.totalTarget.textContent = String(val.length);
		};

		this.inputTarget.addEventListener('input', this.onInput);
		this.onInput();
	}

	disconnect() {
		this.inputTarget.removeEventListener('input', this.onInput);
	}
}
